<template>
  <db-icon
    id="arrow-forward"
    icon="arrow-forward"
    icon-custom
    variant=""
    style="
      --icon-font-size: 5rem;
      --icon-font-family: 'icons-32-outline';
      color: #858379;
      --icon-font-weight: 600;
    "
    class="hydrated"
  ></db-icon>
</template>
